import { render, staticRenderFns } from "./StopChannelDialog.vue?vue&type=template&id=9369ce70&"
import script from "./StopChannelDialog.vue?vue&type=script&lang=js&"
export * from "./StopChannelDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports